<template>
  <div class="DIV">
    <div class="div-row div-bottom news-Medium-24">{{ params.newsTitle }}</div>
    <div class="div-text-left news-Regular-14b6" style="margin-top: 15px">
      <div
        class="div-padding-left"
      >{{ params.company }} &nbsp;&nbsp;&nbsp; {{ formatDate(params.releaseTime) }}</div>
    </div>
    <div class="div-line divcss5"></div>
    <div class="div-bottom10" v-html="params.newsContent"></div>
  </div>
</template>
 
 <script>
import { formatDate } from "@/utils/date";
export default {
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  mounted() {
    console.log(this.params);
  },
  methods: {
    HTMLEncode(text) {
      if (text == undefined) return;

      let temp = document.createElement("div");
      temp.innerHTML = text;
      let output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    },
    formatDate(time) {
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Common/newsDetail.vue